module.exports = __webpack_public_path__ + "static/09-d1b2363a7a48278a7706de31c8f6b3d4.jpg";